function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  x: -1,
  y: -1,
  width: 409,
  height: 663,
  id: "canvas_background",
  fill: "#fff"
}), React.createElement("g", {
  id: "canvasGrid",
  display: "none"
}, React.createElement("rect", {
  id: "svg_3",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  strokeWidth: 0,
  fill: "url(#gridpattern)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.7,
  x: 0.75,
  y: -22.25,
  width: 0,
  height: 1,
  id: "svg_2"
}), React.createElement("g", {
  id: 1
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 66.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p1a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 75.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p1b"
})), React.createElement("g", {
  id: 2
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 99.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p2a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 108.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p2b"
})), React.createElement("g", {
  id: 3
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 133.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p3a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 142.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p3b"
})), React.createElement("g", {
  id: 4
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 165.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p4a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 174.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p4b"
})), React.createElement("g", {
  id: 5
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 224.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p5a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 233.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p5b"
})), React.createElement("g", {
  id: 6
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 257.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p6a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 266.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p6b"
})), React.createElement("g", {
  id: 7
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 291.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p7a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 300.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p7b"
})), React.createElement("g", {
  id: 8
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 323.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p8a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 332.5,
  y: 425,
  width: 10,
  height: 106,
  id: "p8b"
})), React.createElement("g", {
  id: 9
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 66.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p9a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 75.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p9b"
})), React.createElement("g", {
  id: 10
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 99.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p10a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 108.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p10b"
})), React.createElement("g", {
  id: 11
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 133.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p11a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 142.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p11b"
})), React.createElement("g", {
  id: 12
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 165.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p12a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 174.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p12b"
})), React.createElement("g", {
  id: 13
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 224.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p13a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 233.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p13b"
})), React.createElement("g", {
  id: 14
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 257.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p14a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 266.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p14b"
})), React.createElement("g", {
  id: 15
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 291.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p15a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 300.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p15b"
})), React.createElement("g", {
  id: 16
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 323.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p16a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 332.5,
  y: 301,
  width: 10,
  height: 106,
  id: "p16b"
})), React.createElement("g", {
  id: 17
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 66.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p17a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 75.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p17b"
})), React.createElement("g", {
  id: 18
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 99.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p18a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 108.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p18b"
})), React.createElement("g", {
  id: 19
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 133.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p19a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 142.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p19b"
})), React.createElement("g", {
  id: 20
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 165.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p20a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 174.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p20b"
})), React.createElement("g", {
  id: 21
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 224.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p21a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 233.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p21b"
})), React.createElement("g", {
  id: 22
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 257.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p22a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 266.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p22b"
})), React.createElement("g", {
  id: 23
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 291.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p23a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 300.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p23b"
})), React.createElement("g", {
  id: 24
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 323.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p24a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 332.5,
  y: 161,
  width: 10,
  height: 106,
  id: "p24b"
})), React.createElement("g", {
  id: 25
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "50%",
  x: 66.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p25a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 75.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p25b"
})), React.createElement("g", {
  id: 26
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 99.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p26a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 108.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p26b"
})), React.createElement("g", {
  id: 27
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 133.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p27a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 142.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p27b"
})), React.createElement("g", {
  id: 28
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 165.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p28a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 174.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p28b"
})), React.createElement("g", {
  id: 29
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 224.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p29a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 233.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p29b"
})), React.createElement("g", {
  id: 30
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 257.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p30a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 266.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p30b"
})), React.createElement("g", {
  id: 31
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 291.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p31a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 300.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p31b"
})), React.createElement("g", {
  id: 32
}, React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 323.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p32a"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 332.5,
  y: 37,
  width: 10,
  height: 106,
  id: "p32b"
})), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_114",
  cy: 56.77519,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_115",
  height: 4.65115,
  width: 10.85268,
  y: 34.65843,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_116",
  height: 4.65115,
  width: 10.85268,
  y: 74.19319,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_117",
  cy: 116.46492,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_118",
  height: 4.65115,
  width: 10.85268,
  y: 94.34816,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_119",
  height: 4.65115,
  width: 10.85268,
  y: 133.88291,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_120",
  cy: 175.37945,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_121",
  height: 4.65115,
  width: 10.85268,
  y: 153.26269,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_122",
  height: 4.65115,
  width: 10.85268,
  y: 192.79745,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_123",
  cy: 232.74361,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_124",
  height: 4.65115,
  width: 10.85268,
  y: 210.62685,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_125",
  height: 4.65115,
  width: 10.85268,
  y: 250.1616,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_126",
  cy: 288.55737,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_127",
  height: 4.65115,
  width: 10.85268,
  y: 266.44061,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_128",
  height: 4.65115,
  width: 10.85268,
  y: 305.97537,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_129",
  cy: 344.37115,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_130",
  height: 4.65115,
  width: 10.85268,
  y: 322.25439,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_131",
  height: 4.65115,
  width: 10.85268,
  y: 361.78914,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_132",
  cy: 400.18491,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_133",
  height: 4.65115,
  width: 10.85268,
  y: 378.06815,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_134",
  height: 4.65115,
  width: 10.85268,
  y: 417.60291,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_135",
  cy: 456.77387,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_136",
  height: 4.65115,
  width: 10.85268,
  y: 434.65712,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_137",
  height: 4.65115,
  width: 10.85268,
  y: 474.19187,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_138",
  cy: 514.13803,
  cx: 31,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_139",
  height: 4.65115,
  width: 10.85268,
  y: 492.02127,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_140",
  height: 4.65115,
  width: 10.85268,
  y: 531.55602,
  x: 25.51232,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_141",
  cy: 55.22481,
  cx: 378.28568,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_142",
  height: 4.65115,
  width: 10.85268,
  y: 33.10805,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_143",
  height: 4.65115,
  width: 10.85268,
  y: 72.6428,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_144",
  cy: 114.91454,
  cx: 378.28568,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_145",
  height: 4.65115,
  width: 10.85268,
  y: 92.79778,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_146",
  height: 4.65115,
  width: 10.85268,
  y: 132.33253,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_147",
  cy: 173.82907,
  cx: 378.28568,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_148",
  height: 4.65115,
  width: 10.85268,
  y: 151.71231,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_149",
  height: 4.65115,
  width: 10.85268,
  y: 191.24706,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_150",
  cy: 231.19322,
  cx: 378.28568,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_151",
  height: 4.65115,
  width: 10.85268,
  y: 209.07646,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_152",
  height: 4.65115,
  width: 10.85268,
  y: 248.61122,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_153",
  cy: 287.00699,
  cx: 378.28568,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_154",
  height: 4.65115,
  width: 10.85268,
  y: 264.89023,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_155",
  height: 4.65115,
  width: 10.85268,
  y: 303.64979,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_156",
  cy: 342.04557,
  cx: 378.28568,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_157",
  height: 4.65115,
  width: 10.85268,
  y: 319.92881,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_158",
  height: 4.65115,
  width: 10.85268,
  y: 359.46357,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_159",
  cy: 397.85934,
  cx: 378.28568,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_160",
  height: 4.65115,
  width: 10.85268,
  y: 375.74258,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_161",
  height: 4.65115,
  width: 10.85268,
  y: 415.27733,
  x: 372.798,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_168",
  cy: 579.90524,
  cx: 255.80546,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_169",
  height: 4.65115,
  width: 10.85268,
  y: 560.35258,
  x: 250.31778,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_170",
  height: 4.65115,
  width: 10.85268,
  y: 594.75914,
  x: 250.31778,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_171",
  cy: 579.90524,
  cx: 255.80546,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_175",
  height: 10.68375,
  width: 4.2735,
  y: 574.05965,
  x: 270.19643,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_176",
  height: 10.68375,
  width: 4.2735,
  y: 574.487,
  x: 237.29045,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_177",
  height: 4.65115,
  width: 10.85268,
  y: 560.35258,
  x: 302.04129,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_178",
  height: 4.65115,
  width: 10.85268,
  y: 594.75914,
  x: 302.04129,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_179",
  cy: 579.90524,
  cx: 307.52898,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_180",
  height: 10.68375,
  width: 4.2735,
  y: 574.05965,
  x: 321.91994,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_181",
  height: 10.68375,
  width: 4.2735,
  y: 574.487,
  x: 289.01397,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_182",
  height: 4.65115,
  width: 10.85268,
  y: 560.35258,
  x: 351.52584,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_183",
  height: 4.65115,
  width: 10.85268,
  y: 594.75914,
  x: 351.52584,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_184",
  cy: 579.90524,
  cx: 357.01353,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_185",
  height: 10.68375,
  width: 4.2735,
  y: 574.05965,
  x: 371.40449,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_186",
  height: 10.68375,
  width: 4.2735,
  y: 574.487,
  x: 338.49851,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_187",
  height: 4.65115,
  width: 10.85268,
  y: 609.52798,
  x: 352.14759,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_188",
  height: 4.65115,
  width: 10.85268,
  y: 643.93453,
  x: 352.14759,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_189",
  cy: 629.08064,
  cx: 357.63528,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_190",
  height: 10.68375,
  width: 4.2735,
  y: 623.23505,
  x: 372.02624,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_191",
  height: 10.68375,
  width: 4.2735,
  y: 623.6624,
  x: 339.12026,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_192",
  height: 4.65115,
  width: 10.85268,
  y: 610.30323,
  x: 302.46864,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_193",
  height: 4.65115,
  width: 10.85268,
  y: 644.70978,
  x: 302.46864,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_194",
  cy: 629.85589,
  cx: 307.95633,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_195",
  height: 10.68375,
  width: 4.2735,
  y: 624.0103,
  x: 322.34729,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_196",
  height: 10.68375,
  width: 4.2735,
  y: 624.43765,
  x: 289.44132,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_197",
  height: 4.65115,
  width: 10.85268,
  y: 610.73058,
  x: 250.74513,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_198",
  height: 4.65115,
  width: 10.85268,
  y: 645.13713,
  x: 250.74513,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_199",
  cy: 630.28324,
  cx: 256.23282,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_200",
  height: 10.68375,
  width: 4.2735,
  y: 624.43765,
  x: 270.62378,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_201",
  height: 10.68375,
  width: 4.2735,
  y: 624.865,
  x: 237.7178,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_1",
  y2: 610,
  x2: 6,
  y1: 4,
  x1: 6,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_4",
  y2: 449,
  x2: 402,
  y1: 4,
  x1: 402,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_6",
  y2: 4,
  x2: 403,
  y1: 4,
  x1: 5,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_7",
  y2: 657,
  x2: 403,
  y1: 657,
  x1: 200,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_8",
  y2: 657,
  x2: 402,
  y1: 496,
  x1: 402,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_9",
  y2: 657,
  x2: 200,
  y1: 610,
  x1: 200,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_10",
  y2: 610,
  x2: 118,
  y1: 610,
  x1: 5,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_11",
  y2: 610,
  x2: 154,
  y1: 610,
  x1: 144,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_12",
  y2: 657,
  x2: 153,
  y1: 610,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_13",
  y2: 610,
  x2: 199,
  y1: 610,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_14",
  y2: 617,
  x2: 199,
  y1: 617,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_15",
  y2: 624,
  x2: 199,
  y1: 624,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_16",
  y2: 631,
  x2: 199,
  y1: 631,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_17",
  y2: 637,
  x2: 199,
  y1: 637,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_18",
  y2: 643,
  x2: 199,
  y1: 643,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_19",
  y2: 649,
  x2: 199,
  y1: 649,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_20",
  y2: 655,
  x2: 199,
  y1: 655,
  x1: 153,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("g", {
  transform: "rotate(-90 131.00000000000014,626.0000000000001) ",
  id: "svg_5"
}, React.createElement("path", {
  id: "goog1",
  fill: "none",
  d: "m119,614l24,0l0,24l-24,0l0,-24z"
}), React.createElement("circle", {
  id: "goog2",
  r: 2,
  cy: 618,
  cx: 131
}), React.createElement("path", {
  id: "goog3",
  d: "m138,627l0,-2c-1.54,0.02 -3.09,-0.75 -4.07,-1.83l-1.29,-1.43c-0.17,-0.19 -0.38,-0.34 -0.61,-0.45c-0.01,0 -0.01,-0.01 -0.02,-0.01l-0.01,0c-0.35,-0.2 -0.75,-0.3 -1.19,-0.26c-1.05,0.09 -1.81,1.02 -1.81,2.07l0,5.91c0,1.1 0.9,2 2,2l5,0l0,5l2,0l0,-5.5c0,-1.1 -0.9,-2 -2,-2l-3,0l0,-3.45c1.29,1.07 3.25,1.94 5,1.95zm-6.17,5c-0.41,1.16 -1.52,2 -2.83,2c-1.66,0 -3,-1.34 -3,-3c0,-1.31 0.84,-2.41 2,-2.83l0,-2.07c-2.28,0.46 -4,2.48 -4,4.9c0,2.76 2.24,5 5,5c2.42,0 4.44,-1.72 4.9,-4l-2.07,0z"
})), React.createElement("g", {
  transform: "rotate(90 395.00000000000006,474) ",
  id: "svg_22"
}, React.createElement("title", {
  transform: "translate(0,1) translate(0,1) translate(0,1) translate(0,1) translate(-1,0) translate(-1,0) translate(0,-1) translate(1,0) translate(0,1) translate(0,1) translate(0,1) translate(23,-53) translate(361,509) "
}, "Layer 1"), React.createElement("path", {
  d: "m383,462l24,0l0,24l-24,0l0,-24z",
  fill: "none",
  id: "wc1"
}), React.createElement("path", {
  d: "m388.5,484l0,-7.5l-1.5,0l0,-5.5c0,-1.1 0.9,-2 2,-2l3,0c1.1,0 2,0.9 2,2l0,5.5l-1.5,0l0,7.5l-4,0zm12.5,0l0,-6l3,0l-2.54,-7.63c-0.28,-0.82 -1.04,-1.37 -1.9,-1.37l-0.12,0c-0.86,0 -1.63,0.55 -1.9,1.37l-2.54,7.63l3,0l0,6l3,0zm-10.5,-16c1.11,0 2,-0.89 2,-2s-0.89,-2 -2,-2s-2,0.89 -2,2s0.89,2 2,2zm9,0c1.11,0 2,-0.89 2,-2s-0.89,-2 -2,-2s-2,0.89 -2,2s0.89,2 2,2z",
  id: "wc2"
})), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 117,
  y1: 610.5,
  x2: 117,
  y2: 641.5,
  id: "svg_23",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 145,
  y1: 610.5,
  x2: 145,
  y2: 641.5,
  id: "svg_24",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 117,
  y1: 641.5,
  x2: 145,
  y2: 641.5,
  id: "svg_25",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_26",
  y2: 594,
  x2: 124,
  y1: 610,
  x1: 145,
  strokeWidth: 1.5,
  stroke: "#444444",
  fill: "none"
}));

var SvgAnexo5 = function SvgAnexo5(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "90vw",
    height: "80vh",
    viewBox: "0 0 410 665",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAnexo5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/anexo5.85b338bb.svg";
export { ForwardRef as ReactComponent };